.accordion-card {
  background-color: var(--color-grey-200);
  overflow: hidden;
  position: relative;
}

.accordion-card__title {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
  padding: 1.5rem 1rem;
  user-select: none;
}

.accordion-card__title h3 {
  margin: 0;
}

.accordion-card__title:focus-visible {
  text-decoration: underline;
}

.accordion-card__title-icon {
  transform: rotate(-90deg);
  transition: transform 300ms ease-in;
}

.accordion-card__title-icon--expanded {
  transform: rotate(90deg);
  transition: transform 300ms ease-out;
}

.accordion-card__content {
  display: none;
  margin: 0.5rem 2.5rem 2.5rem;
}

.accordion-card__content--expanded {
  display: block;
}
